// Module
var code = "<template style.bind=\"visible ? 'opacity:1;': 'opacity:0'\">\n  <div class=\"drawer\" class.bind=\"visible ? 'visible' : ''\">\n    <slot></slot>\n  </div>\n  <div class=\"drawer__overlay\" class.bind=\"visible ? 'visible' : ''\" click.delegate=\"doClose()\"></div>\n</template>\n";
// Exports
export default code;